<template>
  <div id="cardID" class="card-size">
    <div v-if="typeof item !== 'undefined' && item !== null">
      <div class="first">
        <div class="content between">
          <div style="width:200px">
            <span id="diveename" class="diveename text-48">{{
              item.TreeName
            }}</span>
          </div>
          <div
            :style="{
              visibility: CardNameList.length > 0 ? 'visible' : 'hidden'
            }"
          >
            <div>
              <span class="cardtitle text-12">常見俗名</span>
            </div>
            <div>
              <span id="cardname" class="cardname text-16">
                <span
                  class="d-block"
                  v-for="(t, index) in CardNameList"
                  :key="index"
                  :id="'cardname_' + index"
                  >{{
                    t + (CardNameList.length - 1 != index ? "、" : "")
                  }}</span
                >
                <!-- {{ item.TreeNameZngCard }} -->
              </span>
            </div>
          </div>
          <div style="width:128px;text-align: right;">
            <div>
              <span class="diveetype-title text-18">喬木</span>
            </div>
            <hr style="border: 0.75px solid rgba(81, 136, 94, 0.5)" />
            <div>
              <span id="origin" class="origin text-18">{{ item.Origin }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="second">
        <div class="content between">
          <div>
            <div class="content start" style="flex-wrap: nowrap;">
              <span class="sci-title text-12">學名</span>

              <div class="sci">
                <span id="diveesci" class=" text-34" v-show="sciOK">
                  <!-- <i>{{ item.TreeScientificName }}</i> -->
                  <i>{{ item.TreeScientificNameNstraight1 }}</i>
                  {{ item.TreeScientificNameStraight1 }}
                  <i>{{ item.TreeScientificNameNstraight2 }}</i>
                  {{ item.TreeScientificNameStraight2 }}
                </span>
              </div>
            </div>
            <div class="content start" style="flex-wrap: nowrap;">
              <span class="fam-title text-12">科名</span>
              <div class="fam">
                <span id="diveefam1" class="text-36" v-show="famOK">{{
                  setFmiStr(item.TreeFamilyName, 1)
                }}</span>
                <span id="diveefam2" class="text-30" v-show="famOK">{{
                  setFmiStr(item.TreeFamilyName, 2)
                }}</span>
              </div>
            </div>
          </div>
          <div id="qr-id" class="qrcode"></div>
        </div>
      </div>

      <div class="thirdR">
        <div class="content start">
          <div>
            <span class="innertitle text-14">性狀</span>
          </div>
          <div>
            <span id="leaffeature" class="des text-14">{{
              setDotToComma(item.LeafFeatureCard)
            }}</span>
          </div>
        </div>
        <div class="content start">
          <div><span class="innertitle text-14">樹形</span></div>
          <div>
            <span id="diveefeature" class="des text-14">{{
              setDotToComma(item.TreeFeature)
            }}</span>
          </div>
        </div>
        <div class="content start">
          <div><span class="innertitle text-14">葉形</span></div>
          <div>
            <span id="leafshape" class="des text-14">{{
              setDotToComma(item.LeafShape)
            }}</span>
          </div>
        </div>
        <div class="content start">
          <div><span class="innertitle text-14">花色</span></div>
          <div>
            <span id="flower" class="des text-14">{{
              setDotToComma(item.FlowerColor)
            }}</span>
          </div>
        </div>
        <div class="content start">
          <div><span class="innertitle text-14">果實</span></div>
          <div>
            <span id="fruit" class="des text-14">{{
              setDotToComma(item.Fruit)
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="ma-auto verticalCenter" style="text-align:center">
      查無相關樹種圖鑑資料，請洽管理員
    </div>
  </div>
</template>
<script>
import QRCode from "davidshimjs-qrcodejs";
export default {
  props: {
    city: {
      type: String,
      default: ""
    },
    school: {
      type: String,
      default: ""
    },
    sid: {
      type: Number,
      default: null
    },
    item: {
      type: Object,
      default() {
        return {
          TreeName: "",
          TreeNameZngCard: "",
          Origin: "",
          TreeScientificName: "",
          TreeFamilyName: "",
          LeafFeature: "",
          TreeFeature: "",
          LeafShape: "",
          FlowerColor: "",
          Fruit: ""
        };
      }
    }
  },
  computed: {
    CardNameList() {
      if (typeof this.item.TreeNameZngCard == "string") {
        // 過濾潛在的惡意字符以防止 XSS 攻擊
        const sanitized = this.item.TreeNameZngCard.replace(
          /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
          ""
        ) // 移除 script 標籤
          .replace(/<[^>]+>/g, "") // 移除其他 HTML 標籤
          .replace(/javascript:/gi, "") // 移除 javascript: 協議
          .replace(/on\w+\s*=/gi, ""); // 移除事件處理器（如 onclick, onload 等）

        return sanitized
          .split(",")
          .map(name => name.trim())
          .filter(name => name.length > 0);
      }
      return [];
    }
  },
  data() {
    return {
      sciOK: false,
      famOK: false
    };
  },
  methods: {
    setDotToComma(str) {
      let result = str;
      if (typeof str == "string") {
        result = str
          .replace(/,/g, "、")
          .replace(/，/g, "、")
          .replace(/﹑/g, "、");
      }
      return result;
    },
    getCardNameFontConfig(name) {
      const text = typeof name == "string" ? name : "";
      const effectiveLength = text.replace(/、/g, "").length;

      if (effectiveLength >= 9) {
        return {
          size: 14,
          width: 110,
          space: 0,
          minFontPx: 6,
          height: 40,
          heightTolerancePx: 2,
          lineHeightRatio: 1.2
        };
      }

      if (effectiveLength >= 7) {
        return {
          size: 15,
          width: 106,
          space: 1,
          minFontPx: 6,
          height: 40,
          heightTolerancePx: 2,
          lineHeightRatio: 1.2
        };
      }

      return {
        size: 16,
        width: 106,
        space: 2,
        minFontPx: 8,
        height: 40,
        heightTolerancePx: 2,
        lineHeightRatio: 1.2
      };
    },
    getEstimatedTextWidth(content, size, space = 0) {
      const text = typeof content == "string" ? content : String(content || "");
      let a_num = 0;
      let h_num = 0;

      for (let i = 0; i < text.length; i++) {
        // eslint-disable-next-line no-control-regex
        if (text[i].match(/[\u0000-\u00ff]/g)) {
          h_num++;
        }
        // eslint-disable-next-line no-control-regex
        if (
          text[i].match(/[\uff00-\uffff]/g) ||
          text[i].match(/[\u4e00-\u9fa5]/g)
        ) {
          a_num++;
        }
      }

      return a_num * (size + space) + h_num * (size * 0.5 + space);
    },
    setCardNameFontsize() {
      if (!Array.isArray(this.CardNameList) || this.CardNameList.length === 0) {
        return;
      }

      const cardNames = this.CardNameList.map((name, index) => {
        return name + (this.CardNameList.length - 1 != index ? "、" : "");
      });

      const longestCardName = cardNames.reduce((longest, current) => {
        return current.length > longest.length ? current : longest;
      }, "");

      const cardNameConfig = this.getCardNameFontConfig(longestCardName);
      const targetWidth = cardNameConfig.width;
      const targetHeight =
        cardNameConfig.height + cardNameConfig.heightTolerancePx;
      const lineHeightRatio = cardNameConfig.lineHeightRatio || 1.2;
      let scaledSize = cardNameConfig.size;
      let scaledSpace = cardNameConfig.space;

      let maxEstimatedWidth = 0;
      for (let i = 0; i < cardNames.length; i++) {
        const estimatedWidth = this.getEstimatedTextWidth(
          cardNames[i],
          cardNameConfig.size,
          cardNameConfig.space
        );
        maxEstimatedWidth = Math.max(maxEstimatedWidth, estimatedWidth);
      }

      if (maxEstimatedWidth > targetWidth) {
        const ratio = maxEstimatedWidth / targetWidth;
        scaledSize = Math.floor(cardNameConfig.size / ratio);
        if (cardNameConfig.minFontPx > 0) {
          scaledSize = Math.max(scaledSize, cardNameConfig.minFontPx);
        }
        if (cardNameConfig.space > 0) {
          scaledSpace = Math.max(Math.ceil(cardNameConfig.space / ratio), 0);
        } else {
          scaledSpace = 0;
        }
      }

      let estimatedHeight = cardNames.length * scaledSize * lineHeightRatio;
      while (
        estimatedHeight > targetHeight &&
        scaledSize > cardNameConfig.minFontPx
      ) {
        scaledSize -= 1;
        estimatedHeight = cardNames.length * scaledSize * lineHeightRatio;
      }

      let finalWidth = this.getEstimatedTextWidth(
        longestCardName,
        scaledSize,
        scaledSpace
      );
      while (finalWidth > targetWidth && scaledSpace > 0) {
        scaledSpace -= 1;
        finalWidth = this.getEstimatedTextWidth(
          longestCardName,
          scaledSize,
          scaledSpace
        );
      }
      while (
        finalWidth > targetWidth &&
        scaledSize > cardNameConfig.minFontPx
      ) {
        scaledSize -= 1;
        finalWidth = this.getEstimatedTextWidth(
          longestCardName,
          scaledSize,
          scaledSpace
        );
      }

      for (let i = 0; i < cardNames.length; i++) {
        const doc = document.getElementById("cardname_" + i);
        if (doc != null) {
          doc.style.fontSize = scaledSize * (1 / 16) + "rem";
          doc.style.letterSpacing =
            scaledSpace > 0 ? scaledSpace * (1 / 16) + "rem" : "0rem";
          doc.style.lineHeight = String(lineHeightRatio);
        }
      }
    },
    setFontsize(
      domId,
      content,
      size,
      width = null,
      space = 0,
      lineheight = false,
      minFontPx = 0
    ) {
      let doc = document.getElementById(domId);
      let result_w = 0;
      if (doc != null) {
        const text =
          typeof content == "string" ? content : String(content || "");
        width = width == null ? doc.getBoundingClientRect().width : width;

        doc.style.fontSize = size * (1 / 16) + "rem";
        doc.style.letterSpacing = space > 0 ? space * (1 / 16) + "rem" : "0rem";
        if (lineheight) {
          doc.style.lineHeight = size * 1.1 * (1 / 16) + "rem";
        } else {
          doc.style.lineHeight = "";
        }

        let a_num = 0;
        let h_num = 0;
        for (let i = 0; i < text.length; i++) {
          // eslint-disable-next-line no-control-regex
          if (text[i].match(/[\u0000-\u00ff]/g)) {
            h_num++;
          }
          // eslint-disable-next-line no-control-regex
          if (
            text[i].match(/[\uff00-\uffff]/g) ||
            text[i].match(/[\u4e00-\u9fa5]/g)
          ) {
            a_num++;
          }
        }

        let t_width = this.getEstimatedTextWidth(text, size, space);
        result_w = t_width;
        if (t_width > width) {
          let r = t_width / width;
          let scaledSize = Math.floor(size / r);
          if (minFontPx > 0) {
            scaledSize = Math.max(scaledSize, minFontPx);
          }
          doc.style.fontSize = scaledSize * (1 / 16) + "rem";

          let scaledSpace = 0;
          if (space > 0) {
            scaledSpace = Math.max(Math.ceil(space / r), 0);
            doc.style.letterSpacing = scaledSpace * (1 / 16) + "rem";
          }

          if (lineheight) {
            doc.style.lineHeight =
              Math.floor(scaledSize * 1.1) * (1 / 16) + "rem";
          }

          result_w =
            a_num * (scaledSize + scaledSpace) +
            h_num * (scaledSize * 0.5 + scaledSpace);
        }
        return result_w;
      }
      //diveename
      //cardname
      //origin
      //diveesci
      //diveefam1
      //leaffeature
      //diveefeature
      //leafshape
      //flower
      //fruit
      return result_w;
    },
    setFmiStr(fmiStr, type = 0) {
      let str = "";
      if (typeof fmiStr != "undefined" && fmiStr != null) {
        str = fmiStr
          // eslint-disable-next-line no-invalid-regexp
          .replace(/\s/g, "")
          // eslint-disable-next-line no-invalid-regexp
          .replace(/\(/g, " ")
          // eslint-disable-next-line no-invalid-regexp
          .replace(/\)/g, "");
        if (type == 1) {
          str = str.split(" ").shift();
        } else if (type == 2) {
          str = str.split(" ").pop();
        }
      }
      return str;
    },
    getQR() {
      let url =
        window.location.origin +
        `${process.env.BASE_URL}` +
        "#/Map?" +
        "no=" +
        this.sid +
        "&city=" +
        this.city;
      //  +
      // "&school=" +
      // this.school;

      new QRCode("qr-id", {
        text: url,
        width: 256,
        height: 256,
        typeNumber: 1,
        colorDark: "#70BC51",
        colorLight: "rgba(0,0,0,0)",
        correctLevel: QRCode.CorrectLevel.L
      });
    }
  },
  watch: {
    item() {
      this.sciOK = false;
      this.famOK = false;
      if (typeof this.item !== "undefined" && this.item !== null) {
        this.setFontsize("diveename", this.item.TreeName, 48, 180);
        //this.setFontsize("cardname", this.item.TreeNameZngCard, 16, 90, 5);

        this.setFontsize("diveesci", this.item.TreeScientificName, 34, 293);
        let used = this.setFontsize(
          "diveefam1",
          this.setFmiStr(this.item.TreeFamilyName, 1),
          36,
          293 - 120
        );
        this.setFontsize(
          "diveefam2",
          this.setFmiStr(this.item.TreeFamilyName, 2),
          30,
          293 - 24 - used
        );
        this.$nextTick(() => {
          this.setCardNameFontsize();
          setTimeout(() => {
            this.sciOK = true;
            this.famOK = true;
            this.getQR();
          }, 100);
        });
      }
    }
  },
  mounted() {
    this.sciOK = false;
    this.famOK = false;
    if (typeof this.item !== "undefined" && this.item !== null) {
      this.setFontsize("diveename", this.item.TreeName, 48, 180);
      //this.setFontsize("cardname", this.item.TreeNameZngCard, 16, 90, 5);

      this.setFontsize("diveesci", this.item.TreeScientificName, 34, 293);

      let used = this.setFontsize(
        "diveefam1",
        this.setFmiStr(this.item.TreeFamilyName, 1),
        36,
        293 - 120
      );
      this.setFontsize(
        "diveefam2",
        this.setFmiStr(this.item.TreeFamilyName, 2),
        30,
        293 - 24 - used
      );

      this.$nextTick(() => {
        this.setCardNameFontsize();
        setTimeout(() => {
          this.sciOK = true;
          this.famOK = true;
          this.getQR();
        }, 100);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "Customized";
  src: url("~@/assets/fonts/GenSekiGothicTW-R-01.woff") format("divuetype");
}

#cardID {
  -webkit-text-size-adjust: none !important;
  // font-size: 2.5vw !important;
  font-family: "Customized", "GenSekiGothic TW", "Microsoft JhengHei", Arial,
    "DFKai-SB" !important;
}

// .print-page {
//   width: 100%;
//   height: auto;
//   margin: 0 auto;
//   padding: 0cm;
//   position: relative;
//   /*page-break-after: always !important;*/
//   color: #ece4d9;
//   font-family: Arial, Customized, "GenSekiGothic TW", "Microsoft JhengHei",
//     "DFKai-SB" !important;
// }

// .print-template {
//   display: inline-block;
//   width: 100%;
// }

// input[type="checkbox"] {
//   divansform: scale(1);
//   -ms-divansform: scale(1); /* IE */
//   -moz-divansform: scale(1); /* FireFox */
//   -webkit-divansform: scale(1); /* Safari and Chrome */
//   -o-divansform: scale(1); /* Opera */
// }

label {
  margin: 0px;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.print-page h1,
.print-page h2,
.print-page h3,
.print-page h4,
.print-page h5,
.print-page h6,
.print-page hr,
.print-page p,
.print-page div,
.print-page div,
.print-page div {
  margin: 0;
  padding: 0;
}

.container {
  height: 100%;
}

.card-size {
  margin: auto;
  background-color: #393332;
  color: #ece4d9;
  height: 354px;
  width: 504px;
}

.content.between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.content.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.content.start {
  display: flex;
  justify-content: start;
  align-items: center;
}

.first .content.between {
  padding-top: 12px;
}

.first .diveename {
  color: #70bc51;
  display: inline-block;
  line-height: 1;
  font-weight: bold;
  min-width: 132px;
  max-width: 200px;
  padding: 10px 0 0 16px;
  text-align: justify;
  text-align-last: justify;
  vertical-align: middle;
}

.first .cardtitle {
  padding: 29px 0 3px 0;
  margin: 0 8px 0 10px;
  width: 120px;
  height: 44px;
}

.first .cardname {
  // // 20220118暫時強制
  // word-break: keep-all;
  white-space: nowrap;
  letter-spacing: 0.5rem;
  padding: 0 8px 0 10px;
  min-width: 64px;
  width: 120px;
  display: inline-block;
  // text-align: justify;
  // text-align-last: justify;
  vertical-align: middle;
  line-height: 1.2;
}

.first .diveetype-title {
  font-family: "Customized", "GenSekiGothic TW", "Microsoft JhengHei", Arial,
    "DFKai-SB" !important;
  text-align: right;
  color: #70bc51;
  margin-right: 4px;
  height: 54px;
  width: 100%;
  font-weight: 500;
  font-size: 1.125rem;
  letter-spacing: 4.5px;
  text-align: justify;
  text-align-last: justify;
}

.first .origin {
  font-family: "Customized", "GenSekiGothic TW", "Microsoft JhengHei", Arial,
    "DFKai-SB" !important;
  color: #70bc51;
  margin-right: 4px;
  width: 100%;
  font-weight: 500;
  font-size: 1.125rem;
  letter-spacing: 4.5px;
  text-align: justify;
  text-align-last: justify;
}

.second .content.between {
  border-bottom: 0.75px solid rgba(81, 136, 94, 0.5);
  padding-bottom: 13px;
  padding-top: 13px;
  position: relative;
}

.second .sci-title,
.second .fam-title {
  margin: 9px 22px 9px 22px;
  writing-mode: vertical-rl;
  text-orientation: upright;
  vertical-align: middle;
  letter-spacing: 1px;
  display: inline-block;
}

@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .second .sci {
      width: 308px;
      -webkit-flex: 1 1 auto;
    }

    .second .fam {
      width: 308px;
    }
  }
}
.second .sci {
  color: #f9f7f7;
  // font-style: italic;
  max-width: 308px;
  -webkit-flex: 1 1 auto;
  line-height: 1;
  span {
    display: inline-block;
  }
}

.second .fam {
  // width: 308px;
  max-width: 308px;
  -webkit-flex: 1 1 auto;
}

.second .fam span,
.second .fam span {
  line-height: 1;
  display: inline-block;
}

#diveefam1 {
  margin-right: 24px;
}

.second .qrcode {
  image-rendering: pixelated;
  position: absolute;
  top: 0;
  right: 60px;
  transform: scale(0.3125);
  height: 80px;
  width: 80px;
  margin: -15px 0 0 27px;
}

.thirdR {
  padding-top: 12px;
}

.thirdR .innertitle {
  width: 24px;
  margin: 8px 29px 8px 27px;
  letter-spacing: 1px;
}

.thirdR .des {
  display: inline-block;
  // vertical-align: middle;
  line-height: 1;
  width: 395px;
}

.text-48 {
  font-size: 3rem;
}

.text-40 {
  font-size: 2.5rem;
}

.text-36 {
  font-size: 2.25rem;
}

.text-34 {
  font-size: 2.125rem;
}

.text-30 {
  font-size: 1.875rem;
}

.text-24 {
  font-size: 1.5rem;
}

.text-18 {
  font-size: 1.125rem;
}

.text-16 {
  font-size: 1rem;
}

.text-14 {
  font-size: 0.875rem;
}

.text-12 {
  font-size: 0.75rem;
}
</style>
